module.exports = __webpack_public_path__ + "static/media/tenth_southside_school5.ba04cd24.png";